import { localStorage } from 'src/utils/localStorage';
import QueryStringUtil from 'src/utils/QueryStringUtil';

const TENANT_LOCAL_STORAGE_KEY = 'vp-upload-and-print-tenant';

let tenant: string;
let tenantOverride: string | null;

export function isDevelopmentMode(): boolean {
  const href = window.location.href;
  const isNonProductionUrl =
    href.startsWith('https://upload-and-print.s3.amazonaws.com/') || // Static site S3 bucket
    href.startsWith('https://client.upload-and-print.design.vpsvc.com/') || // Static site CDN
    href.startsWith('https://dev.upload-and-print.vpsvc.com/review/') || // Dev Static site
    href.match(/https:\/\/.*-review-.*\.design\.vpsvc\.com\//) !== null; // Review apps for CDN-backed sites

  return process.env.NODE_ENV !== 'production' || isNonProductionUrl;
}

export function isProdTenant(): boolean {
  if (getTenant() === 'default' || getTenant() === 'dev' || getTenant() === '') {
    return false;
  }
  return true;
}

function getDefaultTenant() {
  return isProd() ? 'prod' : 'dev';
}

function getTenantOverride() {
  if (tenantOverride === undefined) {
    const tenantFromQuery = new URLSearchParams(window.location.search).get('tenant');
    if (tenantFromQuery !== null) {
      localStorage.set(TENANT_LOCAL_STORAGE_KEY, tenantFromQuery);
      tenantOverride = tenantFromQuery;
    } else {
      tenantOverride = localStorage.get(TENANT_LOCAL_STORAGE_KEY);
    }
  }

  return tenantOverride;
}

export function getTenant(): string {
  if (tenant === undefined) {
    const tenantOverride = getTenantOverride();
    tenant = tenantOverride !== null ? tenantOverride : getDefaultTenant();
  }

  return tenant;
}

export function isCareAgent() {
  if (!windowExists()) {
    return false;
  }

  const careAgent = QueryStringUtil.getValueByKey('careAgent') ?? '';
  return careAgent === 'true';
}

export const ownerId = QueryStringUtil.getValueByKey('owner') ?? '';

export function isProd() {
  return !isLocalhost() && !isStaging() && !isBranch();
}

export function windowExists() {
  return typeof window !== 'undefined' && !!window;
}

export function isLocalhost() {
  return windowExists() && /localhost|127\.0\.0\.1|::1/.test(window.location.hostname);
}

export function isStaging() {
  return windowExists() && (/dev\./.test(window.location.hostname) || /staging\./.test(window.location.hostname));
}

export function isBranch() {
  return windowExists() && /\/review\//.test(window.location.hostname);
}
